<template>
    <div class="m-c-list-header">
        <dl class="m-c-list-item__content">
            <div class="m-c-list-item__col">
                <dt class="project">{{ $t.message("project") }}:</dt>
            </div>
            <div class="m-c-list-item__col">
                <dt class="countries">{{ $t.message("grantee") }}:</dt>
            </div>
            <div class="m-c-list-item__col">
                <dt class="countries">
                    {{ $t.message("destinationCountry") }}:
                </dt>
            </div>
            <div class="m-c-list-item__col">
                <dt class="topics">{{ $t.message("topic") }}:</dt>
            </div>
            <div class="m-c-list-item__col">
                <dt class="duration">{{ $t.message("status") }}:</dt>
            </div>
        </dl>
    </div>
</template>

<script>
export default {
    name: "ListHeader",
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
